<template>
<div id="ticketViwer">
    <div class="row">
        <div class="col-12 p-4">
            <div class="text-center mb-4 betcheck">
                <a href="/">
                    <img width="100" src="/static/assets/img/betcheck.svg"/>
                    BETCHECK
                </a>
                <div class="operator"><a href="/">{{ hostname }}</a></div>
            </div>
            <betDetail v-if="betid > 0" :betid="betid" />
            <cashoutButton v-if="bet" :bet="bet" :bi="bet.id" :pin="pin" />
            <div v-if="bet.cashout_amount > 0" class="mt-4 Button-styles-button Button-styles-primary Button-styles-general cashout-box">
                CASHOUT {{ bet.cashout_amount | toMoney(session.currency) }}
            </div>
        </div>
        <div class="col-12 p-4">
            <table class="table">
        <tbody>
            <tr>
            <th>{{ t.status }}:</th>
            <td>
                <div class="MyBetsListItemDesktop-styles-bet-data MyBetsListItemDesktop-styles-bet-status" :class="bet.result.key == 'waiting' ? 'MyBetsListItemDesktop-styles-delivered' : bet.result.key == 'win' || bet.result.key == 'cashout' ? 'MyBetsListItemDesktop-styles-paid-out' : bet.result.key == 'loss' ? 'MyBetsListItemDesktop-styles-lost' : 'MyBetsListItemDesktop-styles-lost'" v-text="bet.result.key == 'waiting' ? t.betting.waiting : bet.result.key == 'win' ? t.betting.win : bet.result.key == 'loss' ? t.betting.loss : bet.result.key == 'cashout' ? t.betting.cashout : t.betting.cancelled"></div>
            </td>
            </tr>
            <tr>
            <th>{{ t.betting.title.date }}:</th>
            <td>
                {{ bet.created_at | moment('D.M HH:mm', session.timezone)}}
            </td>
            </tr>
            <tr>
                <th>{{ t.betting.title.bet_type }}:</th>
                <td>
                    <div class="MyBetsListItemDesktop-styles-bet-data" v-if="bet.type.name === 'single' || bet.type.name === 'multiple'">{{ bet.odd_count }}x {{ t[bet.type.name] }}</div>
                    <div class="MyBetsListItemDesktop-styles-bet-data" v-if="bet.type.name === 'system'">{{ t[bet.type.name] }} ({{ bet.combinations }})</div>                
                </td>
            </tr>
            <tr>
                <th>{{ t.betting.title.stake }}:</th>
                <td>{{ bet.amount | toMoney(bet.currency) }}</td>
            </tr>
            <tr>
                <th>{{ t.betting.title.possible_earnings }}:</th>
                <td>
                    <span class="" v-if="bet.calculated_earnings > 0">{{ bet.calculated_earnings  | toMoney(session.currency) }}</span>
                    <span class="" v-if="bet.calculated_earnings === 0">{{ bet.earnings | toMoney(session.currency) }}</span>
                </td>
            </tr>
            <tr>
                <th>
                    {{ t.betting.title.multiplier }}:
                </th>
                <td>
                    {{ bet.multiplier}}
                </td>
            </tr>
        </tbody>
        </table>
        </div>
    </div>
</div>
</template>

<script>
import cashoutButton from "@/components/sportsbook/widget/cashoutButton";
import betDetail from '@/components/user/account/betDetail'
export default {
        name: 'ticketViewer',
        components: {betDetail, cashoutButton},
        data () {
            return {
                betid: 0,
                bet: null,
                t: this.$root.t,
                session: window.session,
                hostname: window.location.hostname
            }
        },
        mounted () {
            this.betid = parseInt(this.$route.params.id)
            this.pin = parseInt(this.$route.query.pin)
            this.fetchBets()
        },
        methods: {
            async fetchBets() {
            this.$http.get(bsapi + 'api/v1/bet/detail/' + this.betid)
                .then(response => {
                    this.bet = response.body.result.bet;
                    this.items = response.body.result.items;
                }, response => {
                    this.notfound = 1;
                })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.betcheck {
    font-size: 24px;
    font-weight: bold;
    position: relative;
}
.operator {
    position: relative;
    bottom: 30px;
    left: 30px;
    font-size: 16px;
}
#ticketViwer {
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color:rgb(237, 237, 237);
    top: 0;
    left: 0;
    z-index: 1000;
    overflow-y: scroll;
}
#ticketViwer > .row {
    max-width: 600px;
    margin: auto;
}
table {
    background-color: #fff;
    box-shadow: 0 0 2px 0 rgba(var(--black-box-shadow-rgb), .14), 0 1px 3px 0 rgba(var(--black-box-shadow-rgb), .14);
}
table th {
    font-weight: bold;
}
.cashout-box {
    opacity: 0.7;
    pointer-events: none;
}
.cashout-label {
    font-size: 22px
}
</style>



// WEBPACK FOOTER //
// src/components/pages/TicketViewer.vue